import React, { useState, useEffect, useRef } from 'react';
import axios from '@helpers/axios/private.axios';
import { Button } from "@components/library";
import { Link } from 'react-router-dom';
import { Box } from '@mui/material'
import './postbacks.css';
import { PostbackLogs } from './PostbackLogs';

// --- Компонент для налаштувань (стара логіка) ---
const PostbackSettings = () => {
  const [postbacks, setPostbacks] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchPostbacks = async () => {
    setLoading(true);
    try {
      const resp = await axios.get('/postbacks');
      setPostbacks(resp.data.data);
    } catch (error) {
      console.error("Failed to fetch postbacks:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPostbacks();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this postback?')) {
      try {
        await axios.delete(`/postbacks/${id}`);
        fetchPostbacks();
      } catch (error) {
        console.error("Failed to delete postback:", error);
        alert('Failed to delete.');
      }
    }
  };

  const handleStatusChange = async (id, newStatus) => {
    try {
      setPostbacks(currentPostbacks =>
        currentPostbacks.map(pb =>
          pb.id === id ? { ...pb, status: newStatus } : pb
        )
      );
      await axios.post(`/postbacks/${id}/status`, { status: newStatus });
    } catch (error) {
      console.error("Failed to update status:", error);
      alert('Failed to update status.');
      fetchPostbacks();
    }
  };

  return (
    <div>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <h1>Your Postbacks</h1>
        <Link to="/postbacks/create">
          <Button color="orange">+ Add</Button>
        </Link>
      </Box>
      <div className="table">
        <div className="table__tr table__tr--head">
          <Box sx={{ flex: '1 0 10%' }} className="table__td">Type</Box>
          <Box sx={{ flex: '1 0 15%' }} className="table__td">Campaign</Box>
          <Box sx={{ flex: '1 0 15%' }} className="table__td">Event</Box>
          <Box sx={{ flex: '1 0 35%' }} className="table__td">URL</Box>
          <Box sx={{ flex: '1 0 10%' }} className="table__td">Status</Box>
          <Box sx={{ flex: '1 0 5%' }} className="table__td">Actions</Box>
        </div>
        {loading ? (<p style={{ textAlign: 'center', padding: '20px' }}>Loading...</p>) : postbacks.length > 0 ? (
          postbacks.map(pb =>
            <PostbackItem
              key={pb.id}
              postback={pb}
              onDelete={handleDelete}
              onStatusChange={handleStatusChange}
            />
          )
        ) : (
          <div style={{ textAlign: 'center', padding: '40px', background: '#202020', borderRadius: '8px', marginTop: '10px' }}>
            <h3 style={{ marginBottom: '10px' }}>No Postbacks Found</h3>
            <p>You haven't configured any postbacks yet. Click the "+ Add" button to create your first one.</p>
          </div>
        )}
      </div>
    </div>
  );
};

// --- Допоміжні компоненти (залишаються без змін) ---
const ActionsMenu = ({ postbackId, onDelete }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  return (
    <div ref={menuRef} className="actions-container">
      <button onClick={() => setIsOpen(!isOpen)} className="actions-button">&#8942;</button>
      {isOpen && (
        <div className="actions-menu">
          <Link to={`/postbacks/${postbackId}/edit`} className="actions-menu-item">Edit</Link>
          <div className="actions-menu-item" onClick={onDelete}>Delete</div>
        </div>
      )}
    </div>
  );
};
const PostbackItem = ({ postback, onDelete, onStatusChange }) => {
  const handleToggle = () => onStatusChange(postback.id, !postback.status);
  return (
    <div className="table__tr">
      <Box sx={{ flex: '1 0 10%' }} className="table__td">{postback.campaign_name ? 'Campaign' : 'Global'}</Box>
      <Box sx={{ flex: '1 0 15%' }} className="table__td">{postback.campaign_name || 'All campaigns'}</Box>
      <Box sx={{ flex: '1 0 15%' }} className="table__td">{postback.event}</Box>
      <Box sx={{ flex: '1 0 35%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} className="table__td">{postback.url}</Box>
      <Box sx={{ flex: '1 0 10%' }} className="table__td">
        <div className={`status-toggle ${postback.status ? 'enabled' : ''}`} onClick={handleToggle}>
          <div className="status-toggle-handle"></div>
        </div>
      </Box>
      <Box sx={{ flex: '1 0 5%', display: 'flex', justifyContent: 'center' }} className="table__td">
        <ActionsMenu postbackId={postback.id} onDelete={() => onDelete(postback.id)} />
      </Box>
    </div>
  );
};

// --- ГОЛОВНИЙ КОМПОНЕНТ-КОНТЕЙНЕР З ТАБАМИ ---
export const Postbacks = () => {
  const [activeTab, setActiveTab] = useState('settings');

  return (
    <div>
      <div className="tabs-container">
        <button
          className={`tab-button ${activeTab === 'settings' ? 'active' : ''}`}
          onClick={() => setActiveTab('settings')}
        >
          Settings
        </button>
        <button
          className={`tab-button ${activeTab === 'logs' ? 'active' : ''}`}
          onClick={() => setActiveTab('logs')}
        >
          Logs
        </button>
      </div>

      {activeTab === 'settings' && <PostbackSettings />}
      {activeTab === 'logs' && <PostbackLogs />}
    </div>
  );
};